import React, { useState } from 'react'

import cn from 'classnames'

import ChevronDownIcon from '@src/components/icons/ChevronDown'
import SelectFiatModal from '@src/pages/FiatExchange/components/SelectFiatModal'
import { FiatCurrency } from '@src/types/fiat'

interface FiatSelectionPillProps {
    /** Current selected fiat currency (if any) */
    fiat?: FiatCurrency

    /** Callback when user selects a new fiat currency */
    onChange: (fiat?: FiatCurrency) => void

    /** Whether to show the chevron icon */
    useChevronDown?: boolean
}

/**
 * A pill-like UI to display the currently selected fiat currency
 * and open a modal for selection.
 */
const FiatSelectionPill: React.FC<FiatSelectionPillProps> = ({ fiat, onChange, useChevronDown = true }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false)

    const handleOpenModal = () => setIsOpen(true)
    const handleCloseModal = () => setIsOpen(false)

    return (
        <div className='relative'>
            <div
                className={cn(
                    'flex cursor-pointer items-center',
                    isOpen ? 'border-mach-modal-border' : 'border-transparent'
                )}
                onClick={handleOpenModal}
            >
                <div className='flex h-8 w-[50px] items-center md:h-10'>
                    <img
                        src={fiat?.logoURI}
                        onError={e => {
                            e.currentTarget.src = '/assets/token/unknown.png'
                        }}
                        alt={fiat?.symbol ?? 'select-fiat'}
                        className='h-[40px] w-[40px] rounded-full object-cover'
                    />
                </div>
                <p className='max-w-[90px] truncate px-1 text-xl font-medium md:max-w-[110px] md:text-[32px]'>
                    {fiat?.symbol || 'Select'}
                </p>
                {useChevronDown && <ChevronDownIcon />}
            </div>

            <SelectFiatModal
                isOpen={isOpen}
                onClose={handleCloseModal}
                selectedFiat={fiat}
                setSelectedFiat={newFiat => {
                    onChange(newFiat)
                }}
            />
        </div>
    )
}

export default FiatSelectionPill
